import { z } from 'zod';

import { zodApiPollerSecretsBaseSchema } from '~/data/api-poller-secrets/useQueryApiPollerSecrets/validations';

export const zodApiPollerSecretsSearchParamsSchema =
  zodApiPollerSecretsBaseSchema.extend({
    page: z.number().nonnegative().optional().prefault(0),
  });

export type ApiPollerSecretsSearchParams = z.infer<
  typeof zodApiPollerSecretsSearchParamsSchema
>;
